import { render, staticRenderFns } from "./ISAShortPolling.vue?vue&type=template&id=efa35926&"
import script from "./ISAShortPolling.vue?vue&type=script&lang=js&"
export * from "./ISAShortPolling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports